import React from 'react';
import PageSeo from '@/seo/PageSeo';
import html2pdf from 'html2pdf.js';
import { sendGAPageview } from '../utils/gaConsent';
import PrivacyContentFromMarkdown from '../components/Privacy/PrivacyContentFromMarkdown';
import $ from 'jquery';
import LegalDocumentLayout from '../components/Legal/LegalDocumentLayout';

export default function Privacy() {
  $('.popover').hide();
  sendGAPageview({
    hitType: 'pageview',
    page: '/Privacy-policy',
    title: 'Privacy Policy',
  });

  const downloadSummary = () => {
    const element = document.getElementById('printer');
    if (!element) return;
    element.classList.add('pdf-mode');
    const opt = {
      margin: [20, 40, 40, 20] as [number, number, number, number],
      filename: 'privacy-policy.pdf',
      image: { type: 'jpeg' as const, quality: 0.98 },
      html2canvas: { scale: 2, useCORS: true },
      jsPDF: { unit: 'pt', format: 'a4', orientation: 'portrait' as const },
      pagebreak: {
        mode: ['avoid-all', 'css', 'legacy'],
      },
    };
    html2pdf()
      .set(opt)
      .from(element)
      .save()
      .then(() => {
        element.classList.remove('pdf-mode');
      });
  };

  const sections = [
    { id: 'section1', number: '01', label: 'Data controller' },
    { id: 'section2', number: '02', label: 'Data processed, legal basis and storage' },
    { id: 'section4', number: '03', label: 'Data disclosure' },
    { id: 'section5', number: '04', label: 'International transfer' },
    { id: 'section7', number: '05', label: 'Security measures' },
    { id: 'section8', number: '06', label: 'Your rights' },
    { id: 'section9', number: '07', label: 'General' },
  ];

  const contactCard = {
    title: 'Data Protection Contact',
    email: 'dataprotection@disgenet.com',
    phone: '933037654',
  };

  return (
    <React.Fragment>
      <PageSeo
        title="Privacy Policy | DISGENET"
        description="How MedBioinformatics Solutions SL collects, uses and protects personal data on the DISGENET gene-disease association platform."
        path="/Privacy-policy"
      />

      <section>
        <LegalDocumentLayout
          heroTag="Privacy Policy"
          heroTitle={
            <>
              Personal data <em>processing</em> and rights
            </>
          }
          heroSubtitle="Understand how we collect, use, store and protect your personal data when you use DISGENET."
          sections={sections}
          contact={contactCard}
          onDownload={downloadSummary}
        >
          <PrivacyContentFromMarkdown />
        </LegalDocumentLayout>
      </section>
    </React.Fragment>
  );
}
